"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearPersistedChoices = clearPersistedChoices;
exports.getUnavailableChoices = getUnavailableChoices;
exports.getUnavailableChoicesSuccess = getUnavailableChoicesSuccess;
exports.initializePricing = initializePricing;
exports.persistChoicesOnLoad = persistChoicesOnLoad;
exports.persistChoicesOnSelection = persistChoicesOnSelection;
exports.priceChangedFailed = priceChangedFailed;
exports.updateChoice = updateChoice;
exports.updateChoiceSuccess = updateChoiceSuccess;
exports.updateChoices = updateChoices;
exports.updateDisabledChoices = updateDisabledChoices;
exports.updateDropDownChoice = updateDropDownChoice;
exports.updateEstimatedArrivalTime = updateEstimatedArrivalTime;
exports.updatePricing = updatePricing;
exports.updateSelectedChoices = updateSelectedChoices;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _find = _interopRequireDefault(require("lodash/find"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _transform = _interopRequireDefault(require("lodash/transform"));
var _includes = _interopRequireDefault(require("lodash/includes"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _estimatedArrivalTimeApi = _interopRequireDefault(require("../api/estimatedArrivalTimeApi"));
var _pricing = _interopRequireDefault(require("../api/pricing"));
var _unavailableChoicesApi = _interopRequireDefault(require("../api/unavailableChoicesApi"));
var _settings = require("../settings");
var _filterSelections = _interopRequireDefault(require("../utils/filterSelections"));
var _getSelectedChoices = _interopRequireDefault(require("../modules/mapping/getSelectedChoices"));
var _actionTypes = require("./actionTypes");
var _ajaxStatusActions = require("./ajaxStatusActions");
var _getVisualizerImageUrl = _interopRequireDefault(require("./getVisualizerImageUrl"));
var _pricingActions = require("./pricingActions");
var _rulesActions = require("./rulesActions");
var SELECTIONS_SESSION_STORAGE = 'selectionsSessionStorage';
function FetchError(message, validationErrors) {
  this.name = 'FetchError';
  this.message = message;
  this.validationErrors = validationErrors || [];
}
FetchError.prototype = Error.prototype;
function persistChoicesOnSelection(selectedChoices, updatedChoice) {
  var _getSettings = (0, _settings.getSettings)(),
    productId = _getSettings.productId,
    persistenceKey = _getSettings.persistenceKey;
  return {
    type: _actionTypes.PERSIST_CHOICES,
    productId: productId,
    persistenceKey: persistenceKey,
    selectedChoices: selectedChoices,
    updatedChoice: updatedChoice
  };
}
function persistChoicesOnLoad(choices) {
  var _getSettings2 = (0, _settings.getSettings)(),
    productId = _getSettings2.productId,
    persistenceKey = _getSettings2.persistenceKey;
  return {
    type: _actionTypes.PERSIST_LOADED_CHOICES,
    productId: productId,
    persistenceKey: persistenceKey,
    choices: choices
  };
}
function clearPersistedChoices() {
  return {
    type: _actionTypes.CLEAR_PERSISTED_CHOICES
  };
}
function updateChoiceSuccess(optionId, choiceId, choiceValue) {
  var settingDefaultsOnChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    var _getState$configurato = getState().configurator,
      choices = _getState$configurato.choices,
      options = _getState$configurato.options;
    var selectedChoices = (0, _getSelectedChoices["default"])(choices, options);
    var siblingIds = options[optionId].choices.filter(function (id) {
      return id !== choiceId;
    });
    dispatch({
      type: _actionTypes.CHOICE_CHANGED_SUCCESS,
      choiceId: choiceId,
      choiceValue: choiceValue,
      siblingIds: siblingIds,
      settingDefaultsOnChange: settingDefaultsOnChange
    });
    dispatch(persistChoicesOnSelection(selectedChoices, {
      optionId: optionId,
      choiceId: choiceId,
      choiceValue: choiceValue
    }));
  };
}
function updateDisabledChoices(disabledChoiceIds) {
  return function (dispatch, getState) {
    var state = getState().configurator;
    dispatch({
      type: _actionTypes.UPDATE_DISABLED_CHOICES,
      // eslint-disable-next-line no-param-reassign
      disabledChoices: (0, _transform["default"])(disabledChoiceIds, function (obj, it) {
        return obj[it] = state.choices[it];
      }, {})
    });
  };
}
function updateSelectedChoices() {
  return function (dispatch, getState) {
    var _getState$configurato2 = getState().configurator,
      choices = _getState$configurato2.choices,
      options = _getState$configurato2.options;
    var selectedChoices = (0, _getSelectedChoices["default"])(choices, options);
    dispatch({
      type: _actionTypes.UPDATE_SELECTED_CHOICES,
      selectedChoices: selectedChoices
    });
  };
}
function priceChangedFailed(validationErrors) {
  return {
    type: _actionTypes.PRICE_CHANGED_FAILURE,
    validationMessages: validationErrors
  };
}
function estimatedArrivalTimeChangedFailed() {
  return {
    type: _actionTypes.ESTIMATED_ARRIVAL_TIME_CHANGED_FAILURE
  };
}
var estimatedArrivalTimeChangedSuccess = function estimatedArrivalTimeChangedSuccess(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    productionLeadTimeInDays = _ref.productionLeadTimeInDays,
    shipDate = _ref.shipDate;
  return {
    type: _actionTypes.ESTIMATED_ARRIVAL_TIME_CHANGED_SUCCESS,
    startDate: startDate,
    endDate: endDate,
    productionLeadTimeInDays: productionLeadTimeInDays,
    shipDate: shipDate
  };
};
function getUnavailableChoicesSuccess(unavailableOptionChoices) {
  var deselectUnavailableChoices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: _actionTypes.LOAD_UNAVAILABLE_CHOICES_SUCCESS,
    unavailableOptionChoices: unavailableOptionChoices,
    deselectUnavailableChoices: deselectUnavailableChoices
  };
}
function updatePricing() {
  return function (dispatch, getState) {
    var _getSettings3 = (0, _settings.getSettings)(),
      zipcode = _getSettings3.zipcode,
      siteId = _getSettings3.siteId,
      productLineId = _getSettings3.productLineId,
      priceApi = _getSettings3.priceApi;

    // if priceApi was not setup then bail
    if (!priceApi) {
      return;
    }
    var sessionSelections = window.sessionStorage.getItem(SELECTIONS_SESSION_STORAGE);
    var prev = [];
    if (sessionSelections !== null) {
      prev = JSON.parse(sessionSelections);
    }
    var _getState$configurato3 = getState().configurator,
      choices = _getState$configurato3.choices,
      options = _getState$configurato3.options,
      productInfo = _getState$configurato3.productInfo;
    var current = (0, _filter["default"])(choices, function (choice) {
      return (0, _filterSelections["default"])(choice, options, choices);
    }).map(function (item) {
      var option = options[item.optionId];
      return {
        ChoiceId: item.id,
        OptionId: item.optionId,
        ChoiceValue: item.value,
        OptionType: option.isDependent ? '' : option.optionType,
        Tags: item.tags
      };
    });
    window.sessionStorage.setItem(SELECTIONS_SESSION_STORAGE, JSON.stringify(current));

    // Now our state tracking is handled, we have both prev and current selections, call pricing
    var payload = {
      Siteid: siteId,
      ProductId: productInfo.productId,
      VariantId: productInfo.variantId,
      Choices: current,
      PreviousSelections: prev,
      ProductLineId: productLineId
    };
    payload.dispatch = dispatch;
    payload.getState = getState;
    if (zipcode && zipcode.zipcode) {
      payload.Zipcode = zipcode.zipcode;
    }
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    dispatch((0, _pricingActions.beginPriceChange)());
    (0, _pricing["default"])(payload).then(function (response) {
      if (response.status !== 200) {
        throw new Error("An error occurred while fetching: ".concat(response.statusText));
      }
      return response;
    }).then(function (response) {
      return response.data;
    }).then(function (result) {
      if (result.hasValidationErrors && result.validationMessages) {
        throw new FetchError('Error: please fix your selections and try again.', result.validationMessages);
      }
      dispatch((0, _pricingActions.priceChangedSuccess)(result.choiceDeltas, result.asConfigured, result.strikeThroughPriceModel));
    })["catch"](function (error) {
      window.console.error(error);
      if (error.name && error.name === 'FetchError') {
        dispatch(priceChangedFailed(error.validationErrors));
      } else {
        dispatch(priceChangedFailed(error.validationErrors));
      }
    });
  };
}
function updateEstimatedArrivalTime() {
  return function (dispatch, getState) {
    var _getSettings4 = (0, _settings.getSettings)(),
      siteId = _getSettings4.siteId,
      partnerProductId = _getSettings4.partnerProductId,
      cartOmsId = _getSettings4.cartOmsId;
    var _getState$configurato4 = getState().configurator,
      choices = _getState$configurato4.choices,
      options = _getState$configurato4.options;
    var current = (0, _filter["default"])(choices, function (choice) {
      return (0, _filterSelections["default"])(choice, options, choices);
    }).map(function (item) {
      var option = options[item.optionId];
      return {
        ChoiceId: item.id,
        OptionId: item.optionId,
        ChoiceValue: item.value,
        OptionType: option.isDependent ? '' : option.optionType
      };
    });
    window.sessionStorage.setItem(SELECTIONS_SESSION_STORAGE, JSON.stringify(current));

    // Now our state tracking is handled, we have both prev and current selections, call pricing
    var payload = {
      SiteId: siteId,
      PartnerProductId: partnerProductId,
      CartOmsId: cartOmsId,
      Choices: current
    };
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    (0, _estimatedArrivalTimeApi["default"])(payload).then(function (result) {
      dispatch(estimatedArrivalTimeChangedSuccess(result));
    })["catch"](function (error) {
      window.console.error(error);
      dispatch(estimatedArrivalTimeChangedFailed());
    });
  };
}
function getUnavailableChoices() {
  return function (dispatch, getState) {
    var _getSettings5 = (0, _settings.getSettings)(),
      siteId = _getSettings5.siteId,
      unavailableChoicesApiUrl = _getSettings5.unavailableChoicesApiUrl,
      deselectUnavailableChoices = _getSettings5.deselectUnavailableChoices;
    var _getState$configurato5 = getState().configurator,
      options = _getState$configurato5.options,
      choices = _getState$configurato5.choices,
      productInfo = _getState$configurato5.productInfo;
    var selections = (0, _filter["default"])(choices, function (choice) {
      return (0, _filterSelections["default"])(choice, options, choices);
    }).map(function (choice) {
      var option = options[choice.optionId];
      return {
        optionId: option.id,
        choiceId: choice ? choice.id : null,
        choiceValue: choice ? choice.value : null,
        optionTags: option.tags,
        price: choice ? choice.price : null,
        optionType: option.isDependent ? '' : option.optionType
      };
    });
    var payload = JSON.stringify({
      Siteid: siteId,
      ProductId: productInfo.productId,
      Choices: selections
    });
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    return (0, _unavailableChoicesApi["default"])(unavailableChoicesApiUrl, payload, dispatch).then(function (disabledOptions) {
      /* eslint-disable no-param-reassign */
      var disabledOptionChoices = (0, _transform["default"])(disabledOptions, function (opts, option) {
        return opts[option.optionId] = (0, _transform["default"])(option.choiceIds, function (disabledChoices, cid) {
          return disabledChoices[cid] = choices[cid];
        }, {});
      }, {});
      /* eslint-enable no-param-reassign */
      dispatch(getUnavailableChoicesSuccess(disabledOptionChoices, deselectUnavailableChoices === undefined ? false : deselectUnavailableChoices));
    });
  };
}
function handleTwoAndThreeColumnMeasurements(dispatch, options, choiceValue, choices) {
  dispatch((0, _ajaxStatusActions.beginAjaxCall)());
  var threeColumnMeasurementOptions = (0, _filter["default"])(options, function (a) {
    return a.presentationName === 'ThreeColumnMeasurement';
  });
  if (threeColumnMeasurementOptions.length === 3) {
    var _threeColumnMeasureme = (0, _slicedToArray2["default"])(threeColumnMeasurementOptions, 3),
      leftOption = _threeColumnMeasureme[0],
      middleOption = _threeColumnMeasureme[1],
      rightOption = _threeColumnMeasureme[2];
    var equalWidths = Math.floor(choiceValue * 8 / 3) / 8;
    if (leftOption && middleOption && rightOption && choices[leftOption.choices[0]].minValue <= equalWidths) {
      dispatch(updateChoiceSuccess(leftOption.id, leftOption.choices[0], equalWidths, true));
      dispatch(updateChoiceSuccess(middleOption.id, middleOption.choices[0], choiceValue - equalWidths * 2, true));
      dispatch(updateChoiceSuccess(rightOption.id, rightOption.choices[0], equalWidths, true));
    }
  }
  var twoColumnMeasurementOptions = (0, _filter["default"])(options, function (a) {
    return a.presentationName === 'TwoColumnMeasurement';
  });
  if (twoColumnMeasurementOptions.length === 2) {
    var _twoColumnMeasurement = (0, _slicedToArray2["default"])(twoColumnMeasurementOptions, 2),
      _leftOption = _twoColumnMeasurement[0],
      _rightOption = _twoColumnMeasurement[1];
    var extraForTwo = choiceValue * 8 % 2;
    var equalWidthsForTwo = (choiceValue * 8 - extraForTwo) / 2 / 8;
    if (_leftOption && _rightOption && choices[_leftOption.choices[0]].minValue <= equalWidthsForTwo) {
      dispatch(updateChoiceSuccess(_leftOption.id, _leftOption.choices[0], equalWidthsForTwo + extraForTwo / 8, true));
      dispatch(updateChoiceSuccess(_rightOption.id, _rightOption.choices[0], equalWidthsForTwo, true));
    }
  }
}
var isChoiceAlreadySelected = function isChoiceAlreadySelected(option, choices, choiceValue, allowDeselect) {
  if (!allowDeselect && option.isRequired) {
    var previousSelection = (0, _find["default"])(choices, function (choice) {
      return (0, _includes["default"])(option.choices, choice.id) && choice.isSelected;
    });
    if (previousSelection && previousSelection.value === choiceValue) {
      return true;
    }
  }
  return false;
};
function updateChoices(selChoices) {
  window.sessionStorage.setItem('lastChoice', selChoices[selChoices.length - 1].choiceValue);
  var _getSettings6 = (0, _settings.getSettings)(),
    allowDeselect = _getSettings6.allowDeselect,
    onUpdateChoiceSelection = _getSettings6.onUpdateChoiceSelection;
  return function (dispatch, getState) {
    var shouldContinue = false;
    var _getState$configurato6 = getState().configurator,
      options = _getState$configurato6.options,
      choices = _getState$configurato6.choices;
    selChoices.forEach(function (selChoice) {
      var option = options[selChoice.optionId];
      if (!isChoiceAlreadySelected(option, choices, selChoice.choiceValue, allowDeselect)) {
        shouldContinue = true;
      }
    });
    if (!shouldContinue) {
      return _noop["default"];
    }
    selChoices.forEach(function (_ref2) {
      var optionId = _ref2.optionId,
        choiceId = _ref2.choiceId,
        choiceValue = _ref2.choiceValue;
      var selectedChoice = choices[choiceId];
      var option = options[optionId];
      if (selectedChoice.internalName === 'WidthSelection' && option.internalName === 'Width') {
        handleTwoAndThreeColumnMeasurements(dispatch, options, choiceValue, choices);
      }
      dispatch(updateChoiceSuccess(optionId, choiceId, choiceValue));
    });
    var round1 = function round1() {
      return Promise.all([onUpdateChoiceSelection && onUpdateChoiceSelection(), dispatch(getUnavailableChoices(null, getState)), dispatch((0, _rulesActions.executeImmediateRules)())]);
    };
    var round2 = function round2() {
      return Promise.all([dispatch(updatePricing()), dispatch((0, _getVisualizerImageUrl["default"])(selChoices[selChoices.length - 1])), dispatch(updateSelectedChoices())]);
    };
    return round1().then(round2);
  };
}
function updateChoice(optionId, choiceId, choiceValue) {
  window.sessionStorage.setItem('lastChoice', choiceValue);
  var _getSettings7 = (0, _settings.getSettings)(),
    allowDeselect = _getSettings7.allowDeselect,
    onUpdateChoiceSelection = _getSettings7.onUpdateChoiceSelection;
  return function (dispatch, getState) {
    var _getState$configurato7 = getState().configurator,
      options = _getState$configurato7.options,
      choices = _getState$configurato7.choices;
    var option = options[optionId];
    var selectedChoice = choices[choiceId];
    if (!allowDeselect && option.isRequired) {
      var previousSelection = (0, _find["default"])(choices, function (choice) {
        return (0, _includes["default"])(option.choices, choice.id) && choice.isSelected;
      });
      if (previousSelection && previousSelection.value === choiceValue) {
        return _noop["default"];
      }
    }
    if (selectedChoice.internalName === 'WidthSelection' && option.internalName === 'Width') {
      handleTwoAndThreeColumnMeasurements(dispatch, options, choiceValue, choices);
    }
    var round1 = function round1() {
      return Promise.all([dispatch(updateChoiceSuccess(optionId, choiceId, choiceValue)), onUpdateChoiceSelection && onUpdateChoiceSelection(), dispatch(getUnavailableChoices(null, getState)), dispatch((0, _rulesActions.executeImmediateRules)())]);
    };
    var round2 = function round2() {
      return Promise.all([dispatch(updatePricing()), dispatch((0, _getVisualizerImageUrl["default"])({
        choiceId: choiceId,
        optionId: optionId,
        choiceValue: choiceValue
      })), dispatch(updateSelectedChoices())]);
    };
    return round1().then(round2);
  };
}
function updateDropDownChoice(optionId, choiceId, choiceValue) {
  return function (dispatch, getState) {
    var _getState$configurato8 = getState().configurator,
      options = _getState$configurato8.options,
      choices = _getState$configurato8.choices;
    var currentSelection = (0, _find["default"])(options[optionId].choices, function (cid) {
      return choices[cid].isSelected;
    });
    if (!currentSelection || currentSelection.value !== choiceValue) {
      dispatch(updateChoice(optionId, choiceId, choiceValue));
    }
  };
}
function initializePricing(settings) {
  return function (dispatch, getState) {
    var prev = [];
    var _getState$configurato9 = getState().configurator,
      choices = _getState$configurato9.choices,
      options = _getState$configurato9.options;
    var filteredOptions = (0, _filter["default"])(choices, {
      isSelected: true
    });
    var current = filteredOptions.map(function (item) {
      var optionType = options[item.optionId].presentationName;
      return {
        Id: item.id,
        OptionId: item.optionId,
        Value: item.value,
        Type: optionType,
        Tags: item.tags,
        activatesPromo: item.activatesPromo
      };
    });
    window.sessionStorage.setItem(SELECTIONS_SESSION_STORAGE, JSON.stringify(current));
    var payload = {
      Siteid: settings.siteId,
      ProductId: settings.productId,
      CurrentSelections: current,
      PreviousSelections: prev
    };
    payload.dispatch = dispatch;
    payload.getState = getState;
    if (settings.zipcode) {
      payload.Zipcode = settings.zipcode.zipcode;
    }
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    dispatch((0, _pricingActions.beginPriceChange)());
    return (0, _pricing["default"])(payload).then(function (response) {
      if (response.status !== 200) {
        throw new Error("An error occurred while fetching: ".concat(response.statusText));
      }
      return response;
    }).then(function (response) {
      return response.data;
    }).then(function (result) {
      if (result.hasValidationErrors && result.validationMessages) {
        throw new FetchError('Error: please fix your selections and try again.', result.validationMessages);
      }
      dispatch((0, _pricingActions.priceChangedSuccess)(result.choiceDeltas, result.asConfigured, result.strikeThroughPriceModel));
    })["catch"](function (error) {
      window.console.error(error);
      dispatch(priceChangedFailed(error.validationErrors));
    });
  };
}
//# sourceMappingURL=choiceActions.js.map